import styled from 'styled-components';

const TabContainer = styled.div``;

export default TabContainer;
